"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSuccess = exports.requestError = void 0;
const requestSuccess = (type, payload) => ({
  type: "".concat(type, "_SUCCEEDED"),
  payload
});
exports.requestSuccess = requestSuccess;
const requestError = (type, payload) => ({
  type: "".concat(type, "_FAILED"),
  payload
});
exports.requestError = requestError;